import { useState, useEffect, forwardRef, useRef, useImperativeHandle, useContext } from 'react';
import { CreateCourseContext } from '../../../../context/creator/createCourse/CreateCourseContext'
import { Col, Form, FormControl, InputGroup, Row } from "react-bootstrap";
import { RequiredFormMessage, StyledSearchableAsyncSelect, StyledSearchableSelect } from "../CreateCourseStyles";
import Toggle from 'react-toggle'
import CourseStepEnum from '../../../../domain/enum/CourseStepEnum';
import ICreatableSelect from '../../../../domain/util/ICreatableSelect';
import { ICreateCourseFinalizationPayload } from '../../../../domain/payloads/createCourse/ICreateCourseFinalizationPayload'
import ModalCoursePublished from "../components/modals/ModalCoursePublished"
import CurrencyInput from 'react-currency-masked-input'
import CreatorServices from '../../../../services/CreatorServices'
import { IntegrationServices } from '../../../../services/IntegrationServices'
import { useForm } from 'react-hook-form';
import { isAdmin, isAdminGlobal } from '../../../../util/UserUtil';

const creatorService = new CreatorServices();
const integrationServices = new IntegrationServices();

export const CreateCourseFinalizationForm = forwardRef((props, ref) => {

    const {
        course,
        isEdit,
        isChanged,
        setUpdateDate,
        setIsChanged,
        setIsValid,
        setIsLoading,
        setNavigationStep
    } = useContext(CreateCourseContext);

    useImperativeHandle(ref, () => ({
        submit(isBacking: boolean, saveAsDraft: boolean, stepRender?: number) {
            onSubmit(isBacking, saveAsDraft, stepRender);
        }
    }));

    const fetchData = async () => {
        course.installment=== null ? setInstallment(null) : setInstallment({ value: course.installment, label: course.installment + " Parcelas" });
        setValue('courseResponsible', course.courseResponsible);
    }

    const formatCurrencyValue = (value: number | undefined): string | void => {
        if (value !== undefined && value !== null) {
            let stringValue = value.toString();
            let parts = stringValue.split('.');
            if (parts.length === 1) {
                stringValue = stringValue.concat(',00');
            }
            if (parts.length === 2 && parts[1].length === 1) {
                stringValue = stringValue.concat('0');
            }
            return stringValue.replace('.', ',');
        }
    }

    const getPrice = (): string | void => formatCurrencyValue(course.price);
    const getTeacherCost = (): string | void => formatCurrencyValue(course.teacherCost);
    const getOperationalCost = (): string | void => formatCurrencyValue(course.operationalCost);

    const priceRef = useRef<HTMLDivElement>(null);
    const teacherCostRef = useRef<HTMLDivElement>(null);
    const operationalCostRef = useRef<HTMLDivElement>(null);

    const [reload, callReload] = useState(true);
    const [showModalPublished, setShowModalPublished] = useState(false);

    const [toSomeClasses, setToSomeClasses] = useState<boolean>(false);
    const handleApprenticesChange = (event: any) => {
        setSelectedClasses([]);
        setToSomeClasses(event.target.checked);
        setIsChanged(true);
        callReload(!reload);        
    }

    const [isCertificateEnabled, setIsCertificateEnabled] = useState<boolean>(false);
    const onIsCertificateEnabled = (event: any) => {
        setIsChanged(true);
        setIsCertificateEnabled(event.target.checked);        
        callReload(!reload);
    }

    const [installment, setInstallment] = useState<any>(null);

    const onHasInstallmentChange = () => {
        installment === null ? setInstallment({ value: 2, label: "2 Parcelas" }) : setInstallment(null);
    }

    function handleInstallmentChange(onChangeEvent: any,installmentOptions: { value: number; label: string; }[],  setInstallment, setIsChanged, callReload, reload: boolean) {
        let selectedOption = installmentOptions.find((option) => option.value === onChangeEvent.value);
        setInstallment(selectedOption);
        setIsChanged(true);
        callReload(!reload);
    }
    
    const [savedClasses, setSavedClasses] = useState<ICreatableSelect[]>([]) //classes persistas + novas classes adicionadas
    const [selectedClasses, setSelectedClasses] = useState<ICreatableSelect[]>([]) //classes persistidas em banco

    const {
        register,
        formState: { errors, isValid },
        setValue,
        getValues
    } = useForm<ICreateCourseFinalizationPayload>({ mode: "onChange" });

    
    let courseResponsible = register("courseResponsible", { required: false, maxLength: 150 });
    let price = register("price", { required: false});
    let teacherCost = register("teacherCost", { required: false });
    let operationalCost = register("operationalCost", { required: false });

    const [teacherCostError, setTeacherCostError] = useState(false);
    const [operationalCostError, setOperationalCostError] = useState(false);

    const handleCourseResponsibleChange = (e: any) => {
        setValue("courseResponsible", e.target.value, { shouldValidate: true });
        setIsChanged(true);
        callReload(!reload);
    }

    const handlePriceChange = (e:any) => {
        setIsChanged(true);
        callReload(!reload);
    }

    const handleTeacherCostChange = (e: any) => {
        setTeacherCostError(false);
        setIsChanged(true);
        callReload(!reload);
    }

    const handleOperationalCostChange = (e: any) => {
        setOperationalCostError(false);
        setIsChanged(true);
        callReload(!reload);
    }

    const parseCostValue = (ref: React.RefObject<HTMLDivElement>): number | null => {
        const el = ref.current?.querySelector('input');
        if (!el) return null;
        const raw = el.getAttribute('value');
        if (raw === null || raw === '') return null;
        return Number.parseFloat(raw.replace(',', '.'));
    }

    //Class Handlers
    const handleClassesChange = (value: ICreatableSelect, actionMeta: any) => {
        switch (actionMeta.action) {
            case "select-option":
                if (actionMeta.option.label === "Selecionar todas") {
                    setSelectedClasses([]);
                    setSelectedClasses(savedClasses);
                }
                else {
                    let vector = selectedClasses;
                    vector = vector?.concat(actionMeta.option);
                    setSelectedClasses(vector);
                }
                break;
            case "remove-value":
                let vector = selectedClasses;
                vector = vector?.filter((selectedClass) => {
                    return selectedClass.value !== actionMeta.removedValue.value;
                });
                setSelectedClasses(vector);
                break;
        }

        setIsChanged(true);
        callReload(!reload);
    };

    const filterClassess = (inputValue: string, callback) => {
        let responseClass: ICreatableSelect[] = [];
            
        if (inputValue.length >= 3) {
            integrationServices.GetInstitutionGroupsByName(inputValue).then(response => {
                if (response.success && response.result !== null && response.result.length > 0) {
                    responseClass = response.result.map(cla => (
                        { value: cla.id, label: cla.name }
                    ));

                    let newClassVector = savedClasses.concat(responseClass);
                    setSavedClasses(newClassVector);
                    callback(responseClass);
                }
                else                
                    callback(responseClass);                
            });
        }
    };

    const promiseClassess = (inputValue: string) =>
        new Promise<ICreatableSelect[]>((resolve) => {
            if (inputValue.length >= 3) {
                filterClassess(inputValue, function (response) {                    
                    resolve(response);
                })
            }
    });
    
    useEffect(() => {
        setIsCertificateEnabled(course.enableCertificate);
        //setToCreators(course.creator);
        setToSomeClasses(course.courseLinkedClasses.length > 0);
        
        //concatena as turmas ja persistidas no curso a retorno da lista de busca
        if (course.apprentice && course.courseLinkedClasses.length > 0) {
            let courseLinkedClasses: ICreatableSelect[] = [];
            courseLinkedClasses = course.courseLinkedClasses.map(cla => (
                { value: cla.classId, label: cla.className }
            ));
            setSelectedClasses(courseLinkedClasses)
        }

        fetchData();


        callReload(!reload)
    }, []);    

    useEffect(() => {
        setIsValid(true);
        if (toSomeClasses) {
            setIsValid(toSomeClasses && selectedClasses.length > 0);
        }
    }, [reload]);

    const onSubmit = (isBacking: boolean, saveAsDraft: boolean, stepRender?: number) => {
        if (isChanged || (!isBacking && !isBacking && !(stepRender !== undefined))) {
            let priceInput = priceRef.current?.querySelector('input');

            let value = Number.parseFloat(priceInput!.getAttribute('value')!.replace(',','.'));
            let price = value;
            let courseReponsible = getValues('courseResponsible');

            const teacherCostValue = parseCostValue(teacherCostRef);
            const operationalCostValue = parseCostValue(operationalCostRef);

            if (teacherCostValue !== null && isNaN(teacherCostValue)) {
                setTeacherCostError(true);
                return;
            }
            if (operationalCostValue !== null && isNaN(operationalCostValue)) {
                setOperationalCostError(true);
                return;
            }

            let data: ICreateCourseFinalizationPayload = {
                courseId: course.id,
                isEditMode: isEdit || course.courseStepId >= CourseStepEnum.Finalization,
                saveAsDraft: saveAsDraft || isBacking || stepRender !== undefined,
                enableFaq: false,
                enableCertificate: isCertificateEnabled,
                apprentice: true, //toApprentices,
                creator: true, //toCreators,
                linkedClasses: selectedClasses.map(cla => (
                    { id: cla.value }
                ))
            }

            if(price !== undefined){
                data.price = price
            }
            if(courseReponsible!== undefined){
                data.courseResponsible = courseReponsible
            }

            if (teacherCostValue !== null) {
                data.teacherCost = teacherCostValue;
            }
            if (operationalCostValue !== null) {
                data.operationalCost = operationalCostValue;
            }

            data.installment = installment === null ? null : installment.value;
            

            setShowModalPublished(false);
            setIsLoading(true);
            creatorService.createCourseFinalization(data).then(function (response) {
                if (response.success) {
                    updateCourseObj(data);
                    setUpdateDate(response.result.updateDate);

                    setShowModalPublished(!(saveAsDraft || isBacking));
                    setIsChanged(false);
                    setIsLoading(false);

                    if (!saveAsDraft) {
                        setNavigationStep(stepRender ? stepRender : isBacking ? CourseStepEnum.Dependency : CourseStepEnum.Finalization);
                    }
                }
            }).catch(err => {
                setIsLoading(false);
            });

        }
        else {
            setNavigationStep(isBacking ? CourseStepEnum.Dependency : CourseStepEnum.Finalization);
        }
    };

    const updateCourseObj = (data: any) => {
        course.courseStepId = CourseStepEnum.Finalization
        course.enableFaq = data.enableFaq;
        course.enableCertificate = data.enableCertificate;
        course.apprentice = data.apprentice;
        course.price = data.price;
        course.courseResponsible = data.courseResponsible;
        course.creator = data.creator;
        course.teacherCost = data.teacherCost;
        course.operationalCost = data.operationalCost;
        course.courseLinkedClasses = selectedClasses.map(m => ({
            courseId: course.id,
            classId: m.value,
            className: m.label
        }))
    }

    const onReturnHome = () => {
        setShowModalPublished(false);
        window.location.href = "/";
    }

    const installmentOptions = [
        { value: 2, label: "2 Parcelas" },
        { value: 3, label: "3 Parcelas" },
        { value: 4, label: "4 Parcelas" },
        { value: 5, label: "5 Parcelas" },
        { value: 6, label: "6 Parcelas" },
        { value: 7, label: "7 Parcelas" },
        { value: 8, label: "8 Parcelas" },
        { value: 9, label: "9 Parcelas" },
        { value: 10, label: "10 Parcelas" },
        { value: 11, label: "11 Parcelas" },
        { value: 12, label: "12 Parcelas" },

    ];

    const isAdminUser = (isAdmin() || isAdminGlobal())

    return (        
        <Form id="step-form"
        autoComplete='off'>
        <Row>
            <Col md={10} className="mx-auto">
                <Row>
                    <Col>
                        <h1>
                            Filtrar distribuição (opcional)
                        </h1>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p>
                            Deseja distribuir este curso para apenas alguma(s) turma(s)? Escreva o nome da(s) turma(s) e selecione quem você deseja que visualize este curso. <br />
                            <b>Caso não selecione nenhuma turma, o curso será distribuído para todos os usuários.</b>
                        </p>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col md={"auto"} className={"pr-0"}>
                        <Toggle
                            icons={false}
                            checked={toSomeClasses}
                            onChange={handleApprenticesChange}
                        />
                    </Col>
                    <Col md={"auto"} className={"my-auto"}>
                        <label>Distribuir curso apenas para algumas turmas</label>
                    </Col>
                </Row>
                {toSomeClasses &&
                    <Row className="mt-2">
                        <Col>
                            <Form.Group className={toSomeClasses ? "" : "d-none"}>
                                <StyledSearchableAsyncSelect
                                    className='react-select-container'
                                    classNamePrefix="react-select"
                                    placeholder="Digite o nome da(s) turma(s) para buscar e selecionar"
                                    isMulti                                    
                                    cacheOptions
                                    defaultOptions
                                    loadOptions={promiseClassess}
                                    options={savedClasses}
                                    value={selectedClasses}
                                    onChange={handleClassesChange}
                                />

                            </Form.Group>
                        </Col>
                    </Row>
                }
                <Row className="mt-5">
                    <Col>
                        <h1>
                            Certificado de Conclusão (opcional)
                        </h1>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p>
                            Por fim, deseja oferecer um Certificado de Conclusão para o seu curso? Nele estará o nome de quem o completou,
                            o nome do curso e a carga horária.
                        </p>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col md={"auto"} className={"pr-0"}>
                        <Toggle
                            icons={false}
                            checked={isCertificateEnabled}
                            onChange={onIsCertificateEnabled}
                        />
                    </Col>
                    <Col md={"auto"} className={"my-auto"}>
                        <label>Habilitar o Certificado de Conclusão</label>
                    </Col>
                </Row>
                <Row className="mt-5">
                    <Col>
                        <h1>
                            Informações de venda (opcional)
                        </h1>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p>
                            As informações abaixo só são necessárias caso você queira usar nossa plataforma para criar cursos para venda 
                        </p>
                    </Col>
                </Row>
                <Row className="mb-3">
                        <Col md={8}>
                            <Form.Label htmlFor="course-name">Responsável do curso</Form.Label>
                            <InputGroup className="mb-3">
                                <FormControl
                                    id="course-responsible-name"                                    
                                    autoComplete="off"
                                    placeholder="Este é o nome que aparecerá no campo responsável no site de vendas"
                                    aria-describedby="course-responsible-name"
                                    onChange={(e) => {
                                        handleCourseResponsibleChange(e)
                                    }}
                                    onBlur={courseResponsible.onBlur}
                                    ref={courseResponsible.ref} />
                            </InputGroup>
                            {errors.courseResponsible && errors.courseResponsible.type === "maxLength" && (
                                <RequiredFormMessage className="mt-2">Tamanho máximo do texto excedido.</RequiredFormMessage>
                            )}
                        </Col>
                        <Col md={4} >
                            <Form.Label htmlFor="workload">Preço do curso</Form.Label>
                            <InputGroup className="mb-3" ref={priceRef}>
                                <CurrencyInput
                                    autoComplete="off"
                                    id="price"
                                    separator={','}
                                    type="text"
                                    className="form-control"
                                    placeholder="Qual o preço de venda do curso?"                                    
                                    onBlur={price.onBlur}
                                    defaultValue={getPrice()}
                                    onChange={(e:any) => {
                                        handlePriceChange(e)
                                    }}
                                />
                            </InputGroup>  
                            {errors.price && errors.price.type === "required" && (
                                <RequiredFormMessage className="mt-2">Esse campo é obrigatório</RequiredFormMessage>
                            )}
                        </Col>

                    </Row>
                    <Row>
                        <Col md={4}>
                            <p>
                                Aqui você pode formas de parcelamento do curso. Caso não selecione nenhuma, o valor exibido será o valor do curso à vista.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        {
                            installment && 
                            <Col md={2} >
                                <StyledSearchableSelect
                                    classNamePrefix="react-select"
                                    placeholder="Numero de parcelas"
                                    isDisabled={false}
                                    options={installmentOptions}
                                    value={installment}
                                    onChange={onChangeEvent => handleInstallmentChange(onChangeEvent , installmentOptions,  setInstallment, setIsChanged, callReload, reload)}
                                />
                            </Col>
                        }
                        <Col md={5} className="d-flex align-items-center">
                            <Row className="d-flex  align-items-center">
                                <Col md={"auto"} className={"pr-0 d-flex align-items-center"}>
                                    <Toggle
                                        icons={false}
                                        checked={installment !== null ? true : false}
                                        onChange={onHasInstallmentChange}
                                    />
                                </Col>
                                <Col md={"auto"} className={"my-auto d-flex align-items-center"}>
                                    <label>Exibir valor parcelado</label>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {isAdminUser && (
                        <>
                            <Row>
                                <Col className='mt-5'>
                                    <h1>
                                        Custo do professor (opcional)
                                    </h1>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={5} >
                                    <Form.Label htmlFor="teacherCost">Informe o custo relacionado ao professor responsável pelo curso.</Form.Label>
                                    <InputGroup className="mb-3 mr-5" ref={teacherCostRef}>
                                        <CurrencyInput
                                            autoComplete="off"
                                            id="teacherCost"
                                            separator={','}
                                            type="text"
                                            className={`form-control${teacherCostError ? ' border-danger' : ''}`}
                                            placeholder="Qual o custo com professor?"
                                            onBlur={teacherCost.onBlur}
                                            defaultValue={getTeacherCost()}
                                            onChange={(e: any) => {
                                                handleTeacherCostChange(e)
                                            }}
                                        
                                        />
                                    </InputGroup>
                                    {teacherCostError && (
                                        <RequiredFormMessage className="mt-2">Valor inválido. Informe um valor monetário (ex.: 0,00).</RequiredFormMessage>
                                    )}
                                </Col>
                            </Row>
                            <Row>
                                <Col className='mt-3'>
                                    <h1>
                                        Custo operacional (opcional)
                                    </h1>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={5} >
                                    <Form.Label htmlFor="operationalCost">Informe os custos operacionais associados ao curso.</Form.Label>
                                    <InputGroup className="mb-3 mr-5" ref={operationalCostRef}>
                                        <CurrencyInput
                                            autoComplete="off"
                                            id="operationalCost"
                                            separator={','}
                                            type="text"
                                            className={`form-control${operationalCostError ? ' border-danger' : ''}`}
                                            placeholder="Qual o custo operacional do curso?"
                                            onBlur={operationalCost.onBlur}
                                            defaultValue={getOperationalCost()}
                                            onChange={(e: any) => {
                                                handleOperationalCostChange(e)
                                            }}
                                        />
                                    </InputGroup>
                                    {operationalCostError && (
                                        <RequiredFormMessage className="mt-2">Valor inválido. Informe um valor monetário (ex.: 0,00).</RequiredFormMessage>
                                    )}
                                </Col>
                            </Row>
                        </>
                    )}
            </Col>
        </Row>
        <ModalCoursePublished show={showModalPublished} onHide={() => onReturnHome()} />
    </Form>);
});


